<template>
  <b-container fluid>
    <b-row>
      <b-col class="text-center">
        <h1 style="margin-top:25px;">Thank you for registering.</h1>
        <h2> The Minnesota Department of Health will mail a confirmation letter to you at your address on file.</h2>
        
        <div style="margin-top:45px; font-weight:700">
          <p><a href="https://www.health.state.mn.us/people/vitalrecords/registry/register.html">Return to MFAR Registration Information</a></p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {

}
</script>
